import {
    GET_PRE_REGISTRATIONS,
    GET_PRE_REGISTRATIONS_FAIL,
    GET_PRE_REGISTRATIONS_SUCCESS,
    ADD_NEW_PRE_REGISTRATION,
    ADD_PRE_REGISTRATION_SUCCESS,
    ADD_PRE_REGISTRATION_FAIL,
    UPDATE_PRE_REGISTRATION,
    UPDATE_PRE_REGISTRATION_SUCCESS,
    UPDATE_PRE_REGISTRATION_FAIL,
    DELETE_PRE_REGISTRATION,
    DELETE_PRE_REGISTRATION_SUCCESS,
    DELETE_PRE_REGISTRATION_FAIL,

    SET_SELECTED_PRE_REGISTRATION,

    GET_PRE_REGISTRATION_BY_UUID,
    GET_PRE_REGISTRATION_BY_UUID_FAIL,
    GET_PRE_REGISTRATION_BY_UUID_SUCCESS,

    // FOR APPROVE PRE REGISTRATION
    APPROVE_PRE_REGISTRATION,
    APPROVE_PRE_REGISTRATION_SUCCESS,
    APPROVE_PRE_REGISTRATION_FAIL,

    // FOR REJECT PRE REGISTRATION
    REJECT_PRE_REGISTRATION,
    REJECT_PRE_REGISTRATION_SUCCESS,
    REJECT_PRE_REGISTRATION_FAIL,
  
} from "./actionTypes";


/*
export const getPreRegistrations = () => ({
  type: GET_PRE_REGISTRATIONS,
})
  */

export const getPreRegistrations = (filters) => ({
  type: GET_PRE_REGISTRATIONS,
  payload: filters,  
});

export const getPreRegistrationsSuccess = preRegistrations => ({
  type: GET_PRE_REGISTRATIONS_SUCCESS,
  payload: preRegistrations,
})

export const getPreRegistrationsFail = error => ({
  type: GET_PRE_REGISTRATIONS_FAIL,
  payload: error,
})

export const addNewPreRegistration = data => ({
  type: ADD_NEW_PRE_REGISTRATION,
  payload: data,
})

export const addPreRegistrationSuccess = preRegistration => ({
  type: ADD_PRE_REGISTRATION_SUCCESS,
  payload: preRegistration,
})

export const addPreRegistrationFail = error => ({
  type: ADD_PRE_REGISTRATION_FAIL,
  payload: error,
})

export const updatePreRegistration = preRegistration => ({
  type: UPDATE_PRE_REGISTRATION,
  payload: preRegistration,
})

export const updatePreRegistrationSuccess = preRegistration => ({
  type: UPDATE_PRE_REGISTRATION_SUCCESS,
  payload: preRegistration,
})

export const updatePreRegistrationFail = error => ({
  type: UPDATE_PRE_REGISTRATION_FAIL,
  payload: error,
})

export const deletePreRegistration = data => ({
  type: DELETE_PRE_REGISTRATION,
  payload: data,
})

export const deletePreRegistrationSuccess = data => ({
  type: DELETE_PRE_REGISTRATION_SUCCESS,
  payload: data,
})

export const deletePreRegistrationFail = error => ({
  type: DELETE_PRE_REGISTRATION_FAIL,
  payload: error,
})


// SELECTED PRE REGISTRATION
export const setSelectedPreRegistration = (preRegistration) => ({
    type: SET_SELECTED_PRE_REGISTRATION,
    payload: preRegistration,
});


// FOR APPROVE
export const approvePreRegistration = (preRegistration) => ({
  type: APPROVE_PRE_REGISTRATION,
  payload: preRegistration,
})

export const approvePreRegistrationSuccess = (preRegistration) => ({
  type: APPROVE_PRE_REGISTRATION_SUCCESS,
  payload: preRegistration,
})

export const approvePreRegistrationFail = error => ({
  type: APPROVE_PRE_REGISTRATION_FAIL,
  payload: error,
})

// FOR REJECT
export const rejectPreRegistration = (preRegistration) => ({
  type: REJECT_PRE_REGISTRATION,
  payload: preRegistration,
})

export const rejectPreRegistrationSuccess = (preRegistration) => ({
    type: REJECT_PRE_REGISTRATION_SUCCESS,
    payload: preRegistration,
})

export const rejectPreRegistrationFail = error => ({
  type: REJECT_PRE_REGISTRATION_FAIL,
  payload: error,
})

// GET PRE REGISTRATION BY UID
export const getPreRegistrationByUuid = (uuid) => ({
  type: GET_PRE_REGISTRATION_BY_UUID,
  payload: uuid,
});

export const getPreRegistrationByUuidSuccess = (preRegistration) => ({
  type: GET_PRE_REGISTRATION_BY_UUID_SUCCESS,
  payload: preRegistration,
});

export const getPreRegistrationByUuidFail = (error) => ({
  type: GET_PRE_REGISTRATION_BY_UUID_FAIL,
  payload: error,
});










